import axiosAuth from "helpers/axios";
import { backendURL } from "config";

export interface ReportFile {
  key: string;
  size: number;
  last_modified: string | { date?: string; timezone?: string };
  e_tag?: string;
}

export interface GenerateReportsPayload {
  type: "partner" | "all_partners";
  partner_id?: number;
  start_date?: string;
  end_date?: string;
}

export async function generateCsvReports(payload: GenerateReportsPayload) {
  return axiosAuth
    .post(backendURL + "/csv-reports/generate", JSON.stringify(payload))
    .then((res) => res)
    .catch((error) => {
      throw error;
    });
}

export async function listCsvReports() {
  return axiosAuth
    .post(
      backendURL + "/csv-reports/generate",
      JSON.stringify({ type: "list_s3" })
    )
    .then((res) => res)
    .catch((error) => {
      throw error;
    });
}

export async function getCsvReportDownloadUrl(filename: string) {
  return axiosAuth
    .post(
      backendURL + "/csv-reports/generate",
      JSON.stringify({ type: "download", filename })
    )
    .then((res) => res)
    .catch((error) => {
      throw error;
    });
}

export async function cleanupCsvReports(daysOld: number) {
  return axiosAuth
    .post(
      backendURL + "/csv-reports/generate",
      JSON.stringify({ type: "cleanup", days_old: daysOld })
    )
    .then((res) => res)
    .catch((error) => {
      throw error;
    });
}
